import { useMediaQuery } from "@mui/material";
import React from "react";

export default function Footer() {
  const matches = useMediaQuery("(max-width:600px)");
  return (
    <footer className="footersec">
      <div className="container">
        <img style={{ width: matches ? "250px" : "500px" }} src="wp-content/uploads/2022/10/ftr_logo.png" alt="" />
        <h4>
          {" "}
          JOIN US
        </h4>
        <div className="sosbx">
          <ul className="ftr_sos">

            <li>
              <a href="https://t.me/ApeArmyPortal" target="_blank">
                <i className="fa-brands fa-telegram" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/ApeArmyOfficial" target="_blank">
                <i className="fa-brands fa-twitter" />
              </a>
            </li>

          </ul>
          <ul className="leftlist">
            <li>© Ape Army All Rights Reserved</li>
          </ul>

        </div>
      </div>

    </footer>
  );
}
